import React, { useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import GeoclientTour from "./GeoclientTour";

function GeoclientToursInQuoteEdit({
  tours,
  onRemove,
  isProgress,
  handleQuoteEditCancel,
  handleQuoteEditSubmit,
  setQuoteTitle,
  quoteTitle,
}) {
  const [isTitleInputActive, setTitleInputActive] = useState(true);

  const quoteId = localStorage.getItem("quoteId")
    ? localStorage.getItem("quoteId")
    : null;

  function handleTitleEdit() {
    setTitleInputActive(!isTitleInputActive);
  }

  return (
    <>
      <h2>Редактировать подборку {quoteId}</h2>
      <div className="quote__title-container">
        <input
          className={`quote__title ${isTitleInputActive ? "quote__title_active" : ""}`}
          disabled={!isTitleInputActive}
          value={quoteTitle}
          onChange={(e) => setQuoteTitle(e.target.value)}
          placeholder="Имя не задано"
        ></input>
        <button
          type="button"
          className={`btn quote__title-edit-btn ${
            isTitleInputActive ? "quote__title-edit-btn_active" : ""
          }`}
          onClick={handleTitleEdit}
        >
          {isTitleInputActive ? "Сохранить" : "Изменить"}
        </button>
      </div>
      <Droppable droppableId="ToursInQuoteEdit">
        {(provided) => (
          <div
            id="tour-list"
            className="geoclient__tours-list tour-item"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {tours.map((tour, index) => (
              <GeoclientTour
                key={tour.tour_id}
                tour={tour}
                index={index}
                onRemove={onRemove}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <div className="tours__btn-container">
        {isProgress ? (
          <img
            src="https://www.geograftour.com/static/index/img/geoclient-loader.gif"
            style={{ margin: "0 auto" }}
            alt="Анимация загрузки"
          />
        ) : (
          <>
            <button
              id="quote_create"
              className="btn btn-create"
              onClick={handleQuoteEditSubmit}
            >
              Подтвердить редактирование
            </button>
            <button
              id="clear"
              className="btn btn-clear"
              onClick={handleQuoteEditCancel}
            >
              Отмена
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default GeoclientToursInQuoteEdit;
